import { cn } from 'cn';
import { type PaginationSortDirection } from '~/constants';

import { Icon } from '@vestigas/ui/atoms';
import { ChipSelect } from '~/ui/molecules/ChipSelect';

type P<T extends string> = {
  readonly onSortDirectionChange: () => void;
  readonly onSortFieldChange: (
    value: T,
    data?: Record<string, unknown>,
  ) => void;
  readonly sortDirection: PaginationSortDirection;
  readonly sortField: T;
  readonly labels: Record<T, string>;
  readonly values: readonly T[];
} & ComponentStyling;

export function SortOrderSelect<T extends string>({
  className,
  onSortDirectionChange,
  onSortFieldChange,
  sortDirection,
  sortField,
  style,
  labels,
  values,
}: P<T>) {
  const label = (
    <div className="flex w-full min-w-30 items-center justify-between gap-x-1.5">
      <span>{labels[sortField ?? '']}</span>
      <Icon
        className={cn('size-4 transition-all duration-150', {
          'rotate-180': sortDirection === 'ASC',
        })}
        metaphor="arrowDown"
      />
    </div>
  );

  return (
    <ChipSelect
      activeLabel={sortField}
      chipClassName="min-w-30 hover:[&_svg]:text-tiga-action-default hover:[&_svg]:scale-120"
      className={className}
      disableSelectedValue={false}
      label={label}
      options={values.map((value) => ({
        label: labels[value ?? ''],
        value,
        data: {
          label: labels[value ?? ''],
          value,
        },
      }))}
      style={style}
      onClick={onSortDirectionChange}
      onSelect={onSortFieldChange}
    />
  );
}
